import feature from "./feature.vue";
import register from "./store";
import Controller from "./controller";

let AudioConferenceController = new Controller();

export default feature;
export {
    register,
    AudioConferenceController
}
